export enum PendingOperationEnum {
  needAcceptRequiredConsents = 'NEED_ACCEPT_REQUIRED_CONSENTS',
  needConfirmPhone = 'NEED_CONFIRM_PHONE',
  needConfirmEmail = 'NEED_CONFIRM_EMAIL',
  needInsertPhone = 'NEED_INSERT_PHONE',
  needChangePassword = 'NEED_CHANGE_PASSWORD',
  needExternalMatching = 'NEED_EXTERNAL_MATCHING',
  needThinRegistrationConfirmPhone = 'NEED_THIN_REGISTRATION_CONFIRM_CELL',
  needThinRegistrationValidateEmail = 'NEED_THIN_REGISTRATION_VALIDATE_EMAIL',
  needThinRegistrationConfirmEmail = 'NEED_THIN_REGISTRATION_CONFIRM_EMAIL',
  needThinRegistrationGetPassword = 'NEED_THIN_REGISTRATION_GET_PASSWORD',
  needThinRegistrationCheckPhone = 'NEED_THIN_REGISTRATION_CHECK_PHONE',
  needInformationSharing = 'NEED_OAUTH_CONSENT',
}
